"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const BACKEND_URL = react_native_1.Platform.OS === 'web' ? process.env.API_URL : react_native_config_1.default.API_URL;
axios_1.default.defaults.baseURL = BACKEND_URL;
axios_1.default.defaults.headers = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
};
class UserService {
    static async register(data) {
        return new Promise(resolve => {
            axios_1.default
                .post('/user/register', data)
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async checkEmail(data) {
        return new Promise(resolve => {
            axios_1.default
                .post('/user/is-mail-exist', data, {
                validateStatus: status => {
                    return status === 200 || status === 409;
                },
            })
                .then((response) => {
                resolve({
                    error: false,
                    status: response.status,
                    message: response.data.message,
                });
            })
                .catch((error) => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async login(data) {
        console.log(process.env);
        const stayLoggedIn = react_native_1.Platform.OS !== 'web';
        return new Promise(resolve => {
            axios_1.default
                .post('/user/authenticate', { stayLoggedIn: stayLoggedIn, ...data })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async forgotPassword(data) {
        return new Promise(resolve => {
            axios_1.default
                .post('/user/forgot-password', data)
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async resetPassword(data) {
        return new Promise(resolve => {
            axios_1.default
                .post('/user/reset-password', data)
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async deleteAccount() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .delete('/user/delete', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async checkTrackingToken(token) {
        return new Promise(resolve => {
            axios_1.default
                .post('/user/check-token', token)
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async saveTrackingData(data) {
        return new Promise(resolve => {
            axios_1.default
                .post('/user/save-tracking-data', data)
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDataForTracking(token) {
        return new Promise(resolve => {
            axios_1.default
                .post('/user/get-data-for-tracking', token)
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async createPatientAddress(data) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post('/user/createPatientAddress', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async update(data) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .put('/user/update', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async updateUserInfo(data) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .put('/user/update-user-info', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async deleteFile(id) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .delete(`/user/file/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async information() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/user/information', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getFiles() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/user/file', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getFile(id) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get(`/document/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getProgress() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/user/progress', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDoctors() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/user/doctors', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDoctorSlots(doctorId) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get(`/doctor/${doctorId}/free-appointments`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDoctorOnlineSlotsBySlotType(doctorId, slotType) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get(`/doctor/${doctorId}/${slotType}/free-online-appointments`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDoctorSlotsBySlotType(doctorId, slotType) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get(`/doctor/${doctorId}/${slotType}/free-appointments`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getMultipleDoctorOnlineSlotsBySlotType(doctorIds, slotType) {
        const doctorPromises = [];
        const doctorSlots = [];
        new Set(doctorIds).forEach(id => {
            doctorPromises.push(UserService.getDoctorOnlineSlotsBySlotType(id, slotType).then(res => {
                if (res.error) {
                    return {
                        error: true,
                        code: 500,
                        message: 'Error on get doctor slots',
                    };
                }
                doctorSlots.push(...res.data);
            }));
        });
        await Promise.all(doctorPromises);
        return { error: false, data: doctorSlots };
    }
    static async getMultipleDoctorSlotsBySlotType(doctorIds, slotType) {
        const doctorPromises = [];
        const doctorSlots = [];
        new Set(doctorIds).forEach(id => {
            doctorPromises.push(UserService.getDoctorSlotsBySlotType(id, slotType).then(res => {
                if (res.error) {
                    return {
                        error: true,
                        code: 500,
                        message: 'Error on get doctor slots',
                    };
                }
                doctorSlots.push(...res.data);
            }));
        });
        await Promise.all(doctorPromises);
        return { error: false, data: doctorSlots };
    }
    static async uploadFile(file) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post('/user/file', file, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async confirmData() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .put('/user/confirmData', {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async assignDoctorWithType(userId, doctorId, type) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post(`/patient/assign-doctor/${userId}/${doctorId}/${type}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async assignDoctor(userId) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post(`/patient/${userId}/doctor/assign-random`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async confirmTerms(terms) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post('/user/confirmTerms', terms, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async confirmAgbs() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .put('/user/confirmAgbs', {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async confirmPrivacyPolicy() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .put('/user/confirmPrivacyPolicy', {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async activateAccount(token, email) {
        return new Promise(resolve => {
            axios_1.default
                .put('/user/activate', {
                token,
                email,
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async sendDoctorCertificate() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/document/doctor-certificate', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async followPrescription(data) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post('/followup-prescription-question', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async availableFollowupPrescription(patientId, data) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .put(`/patient/${patientId}/available-followup-prescription`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getLocations() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/practice/locations', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getAllDoctors() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/doctor', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDoctorAbsence(doctorId) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get(`/doctor/${doctorId}/absence`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDoctorAbsenceCurrentMonth(doctorId) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get(`/doctor/${doctorId}/absence-current-month`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getDoctor(doctorId) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get(`/doctor/${doctorId}/details`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async getAgreedDataMigrationCompany() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/user/agreedDataMigrationCompany', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async approveDataMigrationCompany() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .put('/user/approveDataMigrationCompany', {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async isMyCannabisPharmacySet() {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .get('/user/isMyCannabisPharmacySet', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
}
exports.default = UserService;
